"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _materialUiPickers = require("material-ui-pickers");

var _dateFns = require("date-fns");

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _dateFns2 = _interopRequireDefault(require("@date-io/date-fns"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _day = _interopRequireDefault(require("./day"));

var _icons = require("../icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var dfnsUtils = new _dateFns2.default();

var validateMinMaxDate = function validateMinMaxDate(day, minDate, maxDate) {
  return minDate && dfnsUtils.isBeforeDay(day, minDate) || maxDate && dfnsUtils.isAfterDay(day, maxDate);
};

var shouldDisableDate = function shouldDisableDate(day, disablePast, disableFuture, minDate, maxDate) {
  return Boolean(disableFuture && dfnsUtils.isAfterDay(day, new Date()) || disablePast && dfnsUtils.isBeforeDay(day, new Date()) || validateMinMaxDate(day, minDate, maxDate));
};

var formats = ['d.L.yy', 'd.L.y', 'd/L/yy', 'd/L/y', 'd-L-yy', 'd-L-y'];

var dateIsValid = function dateIsValid(date) {
  return Object.prototype.toString.call(date) === '[object Date]' && !Number.isNaN(date.getTime());
};

var parseDateText = function parseDateText(text) {
  // eslint-disable-next-line no-restricted-syntax
  for (var _i = 0; _i < formats.length; _i++) {
    var format = formats[_i];
    var d = (0, _dateFns.parse)(text, format, new Date());
    if (dateIsValid(d)) return d;
  }

  return false;
};

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Calendar).call(this, props));
    _this.state = {
      textInput: '',
      inputValid: true
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          value = _this$props.value,
          locale = _this$props.locale;
      this.setState({
        textInput: (0, _dateFns.format)(value, 'P', {
          locale: locale
        })
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props2 = this.props,
          value = _this$props2.value,
          locale = _this$props2.locale;
      var newText = (0, _dateFns.format)(value, 'P', {
        locale: locale
      });
      var textInput = this.state.textInput;
      var prevText = prevState.textInput; // prevText === textInput to avoid running if this change is related to text input change
      // textInput !== newText to avoid infinite loop

      if (prevText === textInput && textInput !== newText) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          textInput: newText
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          classes = _this$props3.classes,
          label = _this$props3.label,
          value = _this$props3.value,
          _onChange = _this$props3.onChange,
          fieldName = _this$props3.fieldName,
          calendarProps = _this$props3.calendarProps,
          onEnterKeyPress = _this$props3.onEnterKeyPress,
          locale = _this$props3.locale;
      var _this$state = this.state,
          textInput = _this$state.textInput,
          inputValid = _this$state.inputValid;
      return _react.default.createElement("div", {
        className: classes.calendarContainer,
        tabIndex: "-1"
      }, _react.default.createElement("div", {
        className: classes.calendarHeader
      }, _react.default.createElement(_InputLabel.default, null, label), _react.default.createElement(_TextField.default, {
        className: classes.dateTextInput,
        error: !inputValid,
        margin: "dense",
        value: textInput,
        onChange: function onChange(e) {
          var input = e.target.value;
          var parsed = parseDateText(input);
          var validInput = false;

          if (parsed && !shouldDisableDate(parsed, calendarProps.disablePast, calendarProps.disableFuture, calendarProps.minDate, calendarProps.maxDate)) {
            _onChange(fieldName, parsed);

            validInput = true;
          }

          _this2.setState({
            textInput: input,
            inputValid: validInput
          });
        },
        onKeyPress: function onKeyPress(ev) {
          if (ev.key === 'Enter') {
            if (onEnterKeyPress) onEnterKeyPress(ev);
            ev.preventDefault();
          }
        }
      }), _react.default.createElement(_IconButton.default, {
        onClick: function onClick() {
          _onChange(fieldName, new Date());

          _this2.setState({
            textInput: (0, _dateFns.format)(new Date(), 'P', {
              locale: locale
            })
          });
        }
      }, _react.default.createElement(_icons.TodayIcon, null))), _react.default.createElement(_Paper.default, {
        tabIndex: "-1",
        elevation: 0,
        className: classes.calPaper,
        style: {
          overflow: 'hidden'
        }
      }, _react.default.createElement(_materialUiPickers.Calendar, _extends({
        allowKeyboardControl: false,
        className: classes.calendar,
        date: value,
        renderDay: function renderDay(day, selectedDate, dayInCurrentMonth) {
          return _react.default.createElement(_day.default, {
            disabled: shouldDisableDate(day, calendarProps.disablePast, calendarProps.disableFuture, calendarProps.minDate, calendarProps.maxDate),
            current: (0, _dateFns.isSameDay)(day, new Date()),
            hidden: !dayInCurrentMonth,
            selected: (0, _dateFns.isSameDay)(selectedDate, day)
          }, (0, _dateFns.getDate)(day));
        },
        tabIndex: -1,
        onChange: function onChange(d) {
          _onChange(fieldName, d);

          _this2.setState({
            textInput: (0, _dateFns.format)(d, 'P', {
              locale: locale
            })
          });
        }
      }, calendarProps))));
    }
  }]);

  return Calendar;
}(_react.Component);

Calendar.propTypes = {
  label: _propTypes.default.any.isRequired,
  value: _propTypes.default.instanceOf(Date).isRequired,
  onChange: _propTypes.default.func.isRequired,
  fieldName: _propTypes.default.string.isRequired,
  calendarProps: _propTypes.default.object,
  onEnterKeyPress: _propTypes.default.func,
  locale: _propTypes.default.object
};
Calendar.defaultProps = {
  calendarProps: {},
  onEnterKeyPress: undefined,
  locale: {}
};

var styles = function styles() {
  return {
    calendarContainer: {
      margin: '1rem'
    },
    calendar: {
      display: 'inline-block'
    },
    calendarHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: '1rem'
    },
    dateTextInput: {
      flexGrow: '1',
      marginLeft: '0.5rem',
      marginRight: '0.5rem'
    }
  };
};

var _default = (0, _styles.withStyles)(styles)(Calendar);

exports.default = _default;